module.exports = __webpack_public_path__ + "html/bg-video-slider_e693068d098e3d084b7d3439fb0ff096.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/bg-video-slider.html
// module id = lc6T
// module chunks = 40